const config = {
  API_URL: window.APP_CONFIG?.API_URL || '',
  ASSET_URL: window.APP_CONFIG?.ASSET_URL || '',
  LIVE_URL: window.APP_CONFIG?.LIVE_URL || '',
  PROJECT_NAME: window.APP_CONFIG?.PROJECT_NAME || ''
};

if (!config.API_URL) {
  console.error('APP_CONFIG.API_URL is not configured');
}

export default config;